import { Injectable } from '@angular/core';
import { SetInitialStateFacade } from '../../../../common/models';
import { CatalogSearchCriteriaFacade, CatalogSearchCriteriaType } from '../../catalog-search-criteria';
import { TransportManagementSearchCriteria } from './models/transport-management.model';
import { TransportManagementLoadFacade } from './load/transport-management-load.facade';
import { TransportManagementTransportOrderFacade } from './transport-order/transport-management-transport-order.facade';
import { ListViewMode } from '../constants';

@Injectable({ providedIn: 'root' })
export class TransportManagementFacade implements SetInitialStateFacade {
  constructor(
    private catalogSearchCriteriaFacade: CatalogSearchCriteriaFacade,
    private transportManagementLoadFacade: TransportManagementLoadFacade,
    private transportManagementTransportOrderFacade: TransportManagementTransportOrderFacade,
  ) {}

  loadAll(searchCriteria?: TransportManagementSearchCriteria): void {
    if (searchCriteria) {
      this.loadByViewMode(searchCriteria);
    } else {
      this.catalogSearchCriteriaFacade
        .getSearchCriteriaByCatalogType(CatalogSearchCriteriaType.TransportManagement)
        .subscribe((searchCriteriaFromStore: TransportManagementSearchCriteria) => {
          this.loadByViewMode(searchCriteriaFromStore);
        });
    }
  }

  setInitialState(): void {
    this.transportManagementLoadFacade.setInitialState();
    this.transportManagementTransportOrderFacade.setInitialState();
  }

  private loadByViewMode(searchCriteria: TransportManagementSearchCriteria): void {
    const { viewMode, ...rest } = searchCriteria;

    if (viewMode === ListViewMode.Load) {
      this.transportManagementLoadFacade.load(rest);
    } else {
      this.transportManagementTransportOrderFacade.load(rest);
    }
  }
}
